import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
const _NotifyPopUp = (props) => {
  const { labelsStore, content } = props;

  return (
    <div className="notify-popup popup-container">
      <PesIcon class="notify-popup__ok-icon" size={pesIconSizes.MICRO}>
        notification_ok_stroke
      </PesIcon>

      <div className="notify-popup__text">
        <p className="notify-popup__title">{labelsStore.clipboardCopied}</p>
        {content && <p className="notify-popup__content">{content}</p>}
      </div>
    </div>
  );
};

_NotifyPopUp.defaultProps = {
  content: ''
};

_NotifyPopUp.propTypes = {
  content: propTypes.string,

  labelsStore: propTypes.shape({
    clipboardCopied: propTypes.string
  }).isRequired
};

export const NotifyPopUp = inject('labelsStore')(observer(_NotifyPopUp));
